import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import CloseIcon from "../img/svg/close_blue_new_design.svg";
import CustomDialog from "./CustomDialog";

const ClubAvailableNextMonthPopup = ({ open, onClose }) => {
  const { t } = useTranslation();

  return (
    <CustomDialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <Box>
        <DialogTitle
          sx={{
            m: 0,
            p: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "3px",
            textAlign: "center",
          }}
          id="customized-dialog-title"
        >
          <img src={CloseIcon} alt="close" onClick={onClose} />
          <Typography
            className="open-sans-hebrew"
            gutterBottom
            sx={{
              fontSize: "24px",
              m: 0,
              color: "var(--darkblue)",
              textAlign: "center",
              fontWeight: 700,
              fontFamily: `var(--font-family) !important`,
            }}
          >
            {t("IMPORTANT")}
          </Typography>
        </DialogTitle>
      </Box>

      <DialogContent>
        <Typography className="almost-finish-dialog-text">
          {t("CLUB_AVAILABLE_NEXT_MONTH")}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: 0, m: 0 }}>
        <Button
          onClick={onClose}
          variant="contained"
          className="almost-finish-dialog-btn"
          sx={{ py: "16px", whiteSpace: "nowrap" }}
        >
          {t("CLOSE")}
        </Button>
      </DialogActions>
    </CustomDialog>
  );
};

export default ClubAvailableNextMonthPopup;
